<template>
  <div class="back-content" style="padding: 70px 10px 10px;">
    <div class="study-menu">
      <study-menu></study-menu>
    </div>
    <router-view name="studyContent" class="study-content"></router-view>
  </div>
</template>

<script>
import StudyMenu from '@/components/study/StudyMenu'
import { FetchAuth } from '@/api/auth'

export default {
  name: 'view-study',
  components: {
    'study-menu': StudyMenu
  },
  watch: {
    $route (to, from) {
      if (to.params.id) {
        this.axios.defaults.headers.common['Study-Id'] = to.params.id
      }
      if (to.params.id !== from.params.id) {
        this.fecthAuth()
      }
    }
  },
  created: function () {
    this.axios.defaults.headers.common['Study-Id'] = this.$route.params.id
    this.fecthAuth()
  },
  methods: {
    fecthAuth: function (studyid) {
      FetchAuth().then(async res => {
        this.$store.dispatch('refreshAuth', res)
      })
    }
  }
}
</script>

<style>
.study-menu {
  margin: 0 auto;
  position: fixed;
  width: 100%;
  z-index: 800;
}
.study-content {
  padding-top: 65px;
}
</style>
